/**
 * The main purpose of this time picker is to call onChange only after full date select
 * and to not re-render parent component on time picker internal state updates
 */

import React from 'react';
import { func } from 'prop-types';
import { TimePicker as AntTimePicker } from 'antd';
import { compose, withState, withHandlers } from 'recompose';

const enhance = compose(
  withState('time', 'setTime', ({ defaultValue = new Date() }) => defaultValue),

  withHandlers({
    onChange: ({ setTime }) => time => setTime(time),
    onOpenChange: ({ onChange, time }) => (openState) => {
      if (openState === false) {
        onChange(time);
      }
    },
  }),
);

const TimePickerComponent = ({ onChange, onOpenChange, ...props }) => (
  <AntTimePicker
    {...props}
    onChange={onChange}
    onOpenChange={onOpenChange}
  />
);

TimePickerComponent.propTypes = {
  onChange: func.isRequired,
  onOpenChange: func.isRequired,
};

export const TimePicker = enhance(TimePickerComponent);



// WEBPACK FOOTER //
// ./src/components/ui-helpers/time-picker.js